import React, { PropTypes } from 'react';
import { FormattedMessage } from 'react-intl';
import ImmutablePropTypes from 'react-immutable-proptypes';

import BcReactComponent from '@bibliocommons/base-bc-react-component';
import { branchShape } from '@bibliocommons/bc-prop-types';
import { TextButton } from '@bibliocommons/base-buttons';
import ScreenReaderMessage from '@bibliocommons/base-screen-reader-message';

import BranchDropdown from '../../../shared/BranchDropdown';

import './HoldsPickupBranchSelect.scss';

const renderDropdownTrigger = (props) => (
  <TextButton showLoadingText {...props} />
);

export default class HoldsPickupBranchSelect extends BcReactComponent {
  constructor(props) {
    super(props);
    this.state = {
      pickupLocation: this.getInitialPickupLocation()
    };

    this.bindAll('handleUpdatePickupLocation', 'isPickupLocationEditable');
  }

  static screenReaderLabel() {
    return (
      <span>
        <ScreenReaderMessage>
          <FormattedMessage id="holds_pickup_dropdown" />
        </ScreenReaderMessage>
      </span>
    );
  }

  getSelectedBranch() {
    const { branches, selected } = this.props;
    return branches.find(b => b.get('code') === selected);
  }

  getInitialPickupLocation() {
    const { branches } = this.props;
    const selectedBranch = this.getSelectedBranch();
    const branch = selectedBranch || branches.first();
    return branch && branch.get('code');
  }

  isPickupLocationEditable() {
    return !this.props.item.get('status').includes('READY_FOR_PICKUP') &&
      this.props.item.get('actions').includes('updateLocation') &&
      this.getSelectedBranch();
  }

  handleUpdatePickupLocation(pickupLocation) {
    this.setState({
      pickupLocation
    });

    this.props.handleUpdatePickupBranch(pickupLocation);
  }

  render() {
    const { item, branches, isLoading, disabled } = this.props;

    return (
      <div className="holds-pickup-branch-select">
        {
          this.isPickupLocationEditable() ?
            (<div className="holds-pickup-dropdown">
              <FormattedMessage
                id="pickup_at_location"
                values={{ location: (
                  <BranchDropdown
                    disabled={disabled}
                    branches={branches}
                    handleSelect={this.handleUpdatePickupLocation}
                    selectedBranchCode={this.state.pickupLocation}
                    ButtonTag={TextButton}
                    isLoading={isLoading}
                    buttonClassName=""
                    renderDropdownTrigger={renderDropdownTrigger}>
                    {HoldsPickupBranchSelect.screenReaderLabel()}
                  </BranchDropdown>
                ) }} />
            </div>) :
            (
              <FormattedMessage
                id="pickup_at_location"
                values={{ location: <span className="branch-name">{item.getIn(['pickupLocation', 'name'])}</span> }} />
            )
        }
      </div>
    );
  }
}

HoldsPickupBranchSelect.propTypes = {
  item: ImmutablePropTypes.map,
  branches: ImmutablePropTypes.listOf(branchShape).isRequired,
  selected: PropTypes.string,
  handleUpdatePickupBranch: PropTypes.func,
  isLoading: PropTypes.bool,
  disabled: PropTypes.bool
};



// WEBPACK FOOTER //
// ./app/components/borrowing/holds/HoldsPickupBranchSelect/HoldsPickupBranchSelect.jsx